export const TIME_OUT_TIME = 3 * 60 * 1000; // 请求超时时间30秒
export const TOAST_STAY_TIME = 3 * 1000; // 右上角提示toast停留时间3秒
export const STATUS_CODE_OK = "1"; // 后台返回正确信息的code标识
export const CODE_UNAUTHORIZED = 401; // 未授权CODE
export const CODE_SERVER_500 = 500; // 服务器500错误
export const GET_BARRAGE_LIST_TIME = 1000 * 60 * 2; // 大屏端弹幕列表查询间隔时间，单位秒
export const HEADER_TOKEN_NAME = "Authorization"; // token传给后台的header名字
export const SESSION_PARAM_LESSION = "SESSION_PARAM_LESSION"; // session中课程的参数
export const SESSION_STORAGE_TOKEN = "SESSION_STORAGE_TOKEN"; // sessionStorage里的token
export const SESSION_STORAGE_OPEN_ID = "SESSION_STORAGE_OPEN_ID"; // sessionStorage里的openId
export const SESSION_STORAGE_BIND = "SESSION_STORAGE_BIND"; // sessionStorage里的是否已经绑定微信帐号
export const SESSION_STORAGE_USER_INFO = "SESSION_STORAGE_USER_INFO"; // sessionStorage里的用户信息
export const SESSION_STORAGE_FINGER = "SESSION_STORAGE_FINGER"; // sessionStorage里的用户指纹信息
export const LOCAL_STORAGE_TRACE_ID = "LOCAL_STORAGE_TRACE_ID"; // localStorage里的用户traceId
export const LOCAL_STORAGE_BOOK_HISTORY = "LOCAL_STORAGE_BOOK_HISTORY"; // localStorage书籍检索历史记录
export const LOCAL_STORAGE_ALEPH_CN_HISTORY = "LOCAL_STORAGE_ALEPH_CN_HISTORY"; // localStorage纸质书中文历史记录
export const LOCAL_STORAGE_ALEPH_EN_HISTORY = "LOCAL_STORAGE_ALEPH_EN_HISTORY"; // localStorage电子书英文历史记录
export const LOCAL_STORAGE_EBOOK_HISTORY = "LOCAL_STORAGE_EBOOK_HISTORY"; // localStorage电子书历史记录
export const LOCAL_STORAGE_SPECIAL_HISTORY = "LOCAL_STORAGE_SPECIAL_HISTORY"; // localStorage特藏历史记录
export const T_DICT_BOOK_AUTHOR_DUTY = "T_DICT_BOOK_AUTHOR_DUTY"; // 著作方式词典
export const T_DICT_BOOK_CLAIMED = "T_DICT_BOOK_CLAIMED"; // 学术成果书籍是否认领词典
export const T_DICT_ARTICLE_SOURCETYPE = "T_DICT_ARTICLE_SOURCETYPE"; // 学术成果成果类型词典
export const T_DICT_ARTICLE_AUTHORTYPE = "T_DICT_ARTICLE_AUTHORTYPE"; // 学术成果作者类型词典
export const T_DICT_ARTICLE_SORTFILED = "T_DICT_ARTICLE_SORTFILED"; // 学术成果排序字段词典
export const T_DICT_ARTICLE_SORTTYPE = "T_DICT_ARTICLE_SORTTYPE"; // 学术成果排序规则词典
export const T_DICT_ARTICLE_CLAIMED = "T_DICT_ARTICLE_CLAIMED"; // 学术成果会议期刊是否认领词典
export const DICT_T_ACTIVITY_TYPE_ONE = "DICT_T_ACTIVITY_TYPE_ONE"; // 活动类型一词典
export const DICT_T_ACTIVITY_TYPE_TWO = "DICT_T_ACTIVITY_TYPE_TWO"; // 活动类型二词典
export const DICT_T_ACTIVITY_STATUS = "DICT_T_ACTIVITY_STATUS"; // 活动状态词典
export const T_DICT_BIZ_LIB = "T_DICT_BIZ_LIB"; // 纸质书书目库词典
export const T_DICT_ALEPH_FIND_TYPE = "T_DICT_ALEPH_FIND_TYPE"; // 纸质书检索类型词典
export const T_DICT_ALEPH_SORT_FILED = "T_DICT_ALEPH_SORT_FILED"; // 纸质书检索排序字段词典
export const T_DICT_ALEPH_SORT_TYPE = "T_DICT_ALEPH_SORT_TYPE"; // 纸质书检索排序类型词典
export const T_DICT_PICKUP_LOC = "T_DICT_PICKUP_LOC"; // 取书点词典
export const T_DICT_BOOK_STATUS = "T_DICT_BOOK_STATUS"; // 图书状态词典
export const DICT_T_SHRFID_RESOURCETYPE = "DICT_T_SHRFID_RESOURCETYPE"; // 学术搜索-资源类型词典
export const DICT_T_SHRFID_SIMQRY_FILED = "DICT_T_SHRFID_SIMQRY_FILED"; // 学术搜索-检索字段词典
export const DICT_THIRD_PLATFORM_INT_TEST = "DICT_THIRD_PLATFORM_INT_TEST"; // 测试信息相关词典表
export const DICT_T_SHRFID_SIMQRY_ORDERFILED =
  "DICT_T_SHRFID_SIMQRY_ORDERFILED"; // 学术搜索-排序字段词典
export const DICT_T_SHRFID_SIMQRY_ORDERTYPE = "DICT_T_SHRFID_SIMQRY_ORDERTYPE"; // 学术搜索-排序方式词典
export const DICT_T_SHRFID_SIMQRY_MATCHTYPE = "DICT_T_SHRFID_SIMQRY_MATCHTYPE"; // 学术搜索-匹配类型词典
export const ALEPH_BOOK_COVER_URL =
  "https://www.bookcovers.cn/index.php?client=libcode&isbn="; // 纸质书封面地址
export const SYSTEM_FLAG = "h5"; // 系统标识
export const UIS_LOGOUT_URL =
  "https://id.fudan.edu.cn/idp/authCenter/GLO?redirectToLogin=true&redirectToUrl=https://mlibrary.fudan.edu.cn/fdlibh5/";
export const TRACE_LOG_URL =
  process.env.NODE_ENV === "development"
    ? `${process.env.VUE_APP_BACK_END_API_PROXY_URL}/common/base/log/push`
    : `${process.env.VUE_APP_BACK_END_API_PX_URL}/common/base/log/push`; // 日志上报接口地址
export const UIS_AUTH_URL =
  process.env.NODE_ENV === "development"
    ? `${process.env.VUE_APP_BACK_END_API_PROXY_URL}/oauth/auth?sourceChannel=h5`
    : `${process.env.VUE_APP_BACK_END_API_PX_URL}/oauth/auth?sourceChannel=h5`; // uis单点登录授权
